import { Routes } from '@angular/router';
import { RegisterComponent } from './auth/register/register.component';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthCallbackComponent } from './auth/auth-callback/auth-callback.component';
import { AuthService } from './auth/shared/services/auth.service';
import { UserProxy } from './proxy/proxies';
import { FeaturesComponent } from './features/features.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { inject } from '@angular/core';
import { SupportComponent } from './features/support/support.component';
import { InvitationComponent } from './features/invitation/invitation.component';
import { HomeComponent } from './features/home/home.component';
import { CSIRoutes } from './features/csi/csi.routes';
import { ServicesRoutes } from './features/services/services.routes';
import { servicesUrlNormalizeGuard } from './features/services/services-url-normalize.guard';
import { CSIGuard } from './core/guards/csi.guard';
import { AppGuard } from './app.guard';
import { ActivitiesRoutes } from './features/activities/activities.routes';
import { SustainabilityDashboardRoutes } from './features/sustainability-dashboard-static/sustainability-dashboard.routes';
import { SustainabilityDashboardRoutes as NewSustainabilityDashboardRoutes } from './features/sustainability-dashboard/sustainability-dashboard.routes';
import { SustainabilityDashboardGuard } from './core/guards/sustainability-dashboard.guard';

export const routes: Routes = [
  { path: '', component: AuthComponent },
  { path: 'Invitation/:invitationId', component: InvitationComponent },
  { path: 'invitation/:invitationId', component: InvitationComponent },
  {
    path: 'auth',
    providers: [AuthService, UserProxy],
    children: [
      // {
      //   path: '',
      //   redirectTo: 'login'
      // },
      { path: 'login', component: LoginComponent },
      { path: 'login/forgot-password', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'callback', component: AuthCallbackComponent },
    ],
  },
  {
    path: '',
    canActivate: [() => inject(AuthGuard).canActivate(), AppGuard],
    component: FeaturesComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: window.location.hostname?.includes('sustainability.doktar') ? '/csi' : '/home'
      },
      {
        path: 'account',
        canActivate: [() => inject(AuthGuard).canActivate()],
        providers: [AuthService],
        children: [
          {
            path: '',
            loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent),
          },
          {
            path: ':state',
            loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent),
          },
          {
            path: ':state/:id',
            loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent),
          },
          {
            path: ':state/:id/:action',
            loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent),
          },
          {
            path: ':state/:id/:action/:actionId',
            loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent),
          },
        ],
      },
      {
        path: 'support',
        providers: [AuthService],
        children: [{ path: '', component: SupportComponent }],
      },
      {
        path: 'support-ticket',
        providers: [AuthService],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/support-ticket/support-ticket.component').then((m) => m.SupportTicketComponent),
          },
        ],
      },
      {
        path: 'lands',
        providers: [AuthService],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/lands-and-plantations/lands-and-plantations.component').then(
                (m) => m.LandsAndPlantationsComponent
              ),
          },
          {
            path: 'add',
            loadComponent: () =>
              import('./features/lands-and-plantations/registeration/registeration.component').then(
                (m) => m.RegisterationComponent
              ),
          },
          {
            path: ':landId',
            loadComponent: () =>
              import('./features/lands-and-plantations/lands-and-plantations.component').then(
                (m) => m.LandsAndPlantationsComponent
              ),
          },
          {
            path: ':landId/add-plantation',
            loadComponent: () =>
              import(
                './features/lands-and-plantations/add-plantation-to-existing-land/add-plantation-to-existing-land.component'
              ).then((m) => m.AddPlantationToExistingLandComponent),
          },
          {
            path: ':landId/:plantationId',
            loadComponent: () =>
              import('./features/lands-and-plantations/lands-and-plantations.component').then(
                (m) => m.LandsAndPlantationsComponent
              ),
          },
        ],
      },
      {
        path: 'home',
        providers: [AuthService],
        children: [{ path: '', component: HomeComponent }],
      },
      {
        path: 'services',
        canActivate: [servicesUrlNormalizeGuard],
        providers: [AuthService],
        children: [ServicesRoutes],
      },
      {
        path: 'services/:plantationId',
        canActivate: [servicesUrlNormalizeGuard],
        providers: [AuthService],
        children: [ServicesRoutes],
      },
      {
        path: 'csi',
        canActivate: [() => inject(CSIGuard).canActivate()],
        providers: [AuthService],
        children: [CSIRoutes],
      },
      {
        path: 'activities',
        providers: [AuthService],
        children: [ActivitiesRoutes],
      },
      {
        path: 'sustainability-dashboard-s',
        canActivate: [() => inject(SustainabilityDashboardGuard).canActivate()],
        providers: [AuthService],
        children: [SustainabilityDashboardRoutes],
      },
      {
        path: 'sustainability-dashboard-d',
        canActivate: [() => inject(SustainabilityDashboardGuard).canActivate()],
        providers: [AuthService],
        children: [NewSustainabilityDashboardRoutes],
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
